import React                             from 'react';
import PropTypes                         from 'prop-types';
import Flux                              from '../../flux/Flux';
import DailybonusTodayVideoOffer         from './DailybonusTodayOffers/DailybonusTodayVideoOffer';
import DailybonusTodayPhotoOffer         from './DailybonusTodayOffers/DailybonusTodayPhotoOffer';
import DailybonusTodayTopUpOffer         from './DailybonusTodayOffers/DailybonusTodayTopUpOffer';
import DailybonusTodayMerchOffer         from './DailybonusTodayOffers/DailybonusTodayMerchOffer';
import DailybonusTodayMessengerGiftOffer from './DailybonusTodayOffers/DailybonusTodayMessengerGiftOffer';
import DailybonusTodayVipOneDayOffer     from './DailybonusTodayOffers/DailybonusTodayVipOneDayOffer';
import DailybonusTodayVoucherOffer       from './DailybonusTodayOffers/DailybonusTodayVoucherOffer';

const {offers} = Flux.Constants.DailyBonuses;

class DailybonusTodayItem extends React.Component {
	
	render() {
		const {offer} = this.props;
		switch (offer) {
			case (offers.VIDEO_VOUCHER):
				return (
					<DailybonusTodayVoucherOffer
						purchased={this.props.purchased}
						offer={this.props.offer}
						effect={this.props.effect}
						conditions={this.props.conditions}
						quantity={this.props.quantity}
					/>
				);
			case (offers.VIP):
				return (
					<DailybonusTodayVipOneDayOffer
						content={this.props.content}
						purchased={this.props.purchased}
						offer={this.props.offer}
						conditions={this.props.conditions}
						effect={this.props.effect}
					/>
				);
			case (offers.VIDEO):
				return (
					<DailybonusTodayVideoOffer
						content={this.props.content}
						conditions={this.props.conditions}
						offer={this.props.offer}
						purchased={this.props.purchased}
						effect={this.props.effect}
						quantity={this.props.quantity}
						free={this.props.free}
					/>
				);
			case (offers.PHOTO_ALBUM):
				return (
					<DailybonusTodayPhotoOffer
						content={this.props.content}
						conditions={this.props.conditions}
						offer={this.props.offer}
						purchased={this.props.purchased}
						effect={this.props.effect}
						free={this.props.free}
					/>
				);
			case (offers.MESSENGER_GIFT):
				return (
					<DailybonusTodayMessengerGiftOffer
						offer={this.props.offer}
						effect={this.props.effect}
						purchased={this.props.purchased}
						conditions={this.props.conditions}
						content={this.props.content}
						quantity={this.props.quantity}
					/>
				);
			case (offers.MERCHANDISE):
				return (
					<DailybonusTodayMerchOffer
						offer={this.props.offer}
						effect={this.props.effect}
						purchased={this.props.purchased}
					/>
				);
			case (offers.TOP_UP_PERCENT):
			case (offers.TOP_UP_FLAT):
				return (
					<DailybonusTodayTopUpOffer
						offer={this.props.offer}
						effect={this.props.effect}
						purchased={this.props.purchased}
						content={this.props.content}
						conditions={this.props.conditions}
					/>
				);
			default:
				return null;
		}
	}
}

DailybonusTodayItem.propTypes = {
	content:    PropTypes.shape({
		id:              PropTypes.number,
		name:            PropTypes.string,
		title:           PropTypes.string,
		imageUrl:        PropTypes.string,
		ageRating:       PropTypes.number,
		duration:        PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		preview:         PropTypes.object,
		photos:          PropTypes.object,
		translations:    PropTypes.object,
		price:           PropTypes.object,
		dailyBonusPrice: PropTypes.object,
		model:           PropTypes.object,
	}),
	conditions: PropTypes.array,
	offer:      PropTypes.string,
	purchased:  PropTypes.bool,
	effect:     PropTypes.object,
	quantity:   PropTypes.number,
	free:       PropTypes.bool,
};

DailybonusTodayItem.defaultProps = {
	free: false,
};

export default DailybonusTodayItem;

